import React, { Component } from 'react';
import '../myutils';
import {
  SimpleForm,
  translate,
} from 'react-admin'; 
import BookIcon from '@material-ui/icons/Book'; 
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { configAPI } from '../config'
import Lock from '@material-ui/icons/LockOpen';
import { Tooltip } from '@material-ui/core';
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

export const TemplateIcon = BookIcon;

class LockFile extends Component {

  state = {
    open: false,
    checked: []
  };
  constructor(props) {
    super(props);
    this.state = {
      record: false,
      fileName: '',
      fileExt: '',
      openReplaceDialog: false,
      checked: [],
      userList: [],
      extsArray: [],
      defaultCheck:[]
    }

  }

  handleClickOpen = (e) => {
    e.stopPropagation();
    this.checkUsers();
  };

  handleClose = (e) => {
    e.stopPropagation();
    this.props.handleCloseMenu()
    this.setState({ open: false });
  };

  handleCloseReplaeDialog = (e) => {
    (e !== undefined) && e.stopPropagation();
    this.setState({
      openReplaceDialog: false,
    });
  };



  checkUsers() {
    const request = new Request(configAPI.api.prod + '/GetIVR2Dir?&path=ivr2:/AutherizedUsers&token=' + sessionStorage.B.encodeDecode(), {
      headers: new Headers({
        'Content-Type': 'text/json'
      }),
      method: 'GET'
    });
    return fetch(request)
      .then(response => { return response.json(); })
      .then(IVRDIR => {
        if (IVRDIR.responseStatus === 'ERROR') {
          sessionStorage.setItem('C', 'ADMIN'.encodeDecode());
          sessionStorage.setItem('D', 'undefinedORempty'.encodeDecode());;}
        else {
          if (IVRDIR.files.length > 0) {
            this.setState({ userList: [] });
            IVRDIR.files.forEach(file => {
              if (file.name!=='ADMIN.txt') this.state.userList.push(file.name.replace(/\.[^/.]+$/, ""));
            });
            this.state.userList.forEach(element => {
              const request = new Request(configAPI.api.prod + '/DownloadFile?path=ivr2:/AutherizedUsers/'+element+'.txt&token=' + sessionStorage.B.encodeDecode(),{
                headers: new Headers({
                    'Content-Type': 'text/json'
                }),
                method: 'GET'
            });
            fetch(request).then(data => data.text())
            .then(data => {
              var filename = data.match(/^\*.*\*/gm);
              filename = filename[0].replace(/\*/g,'');
              if (data.indexOf('['+this.props.record.what+']')>-1) this.state.checked.push(filename);
              if (this.state.userList[this.state.userList.length-1]===filename) this.setState({ open: true });
            })

            });
            
          }
        }
      });
  }


updateUser () {
        var checklist = this.state.checked;
        var unchecked = this.state.userList.filter(function(val) {
          return checklist.indexOf(val) === -1;
        });

        this.state.checked.forEach(element => {
          const request = new Request(configAPI.api.prod + '/DownloadFile?path=ivr2:/AutherizedUsers/'+element+'.txt&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
          });
          fetch(request).then(data => data.text())
            .then(data => {
            var contents = data;
            var filename = data.match(/^\*.*\*/gm);
            filename = filename[0].replace(/\*/g,'');
            if (contents.indexOf('['+this.props.record.what+']')===-1){
              contents=contents+'%0D%0A['+this.props.record.what+']';
              const request = new Request(configAPI.api.prod + '/UploadTextFile?&token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:AutherizedUsers/'+filename+'.txt&contents=' + contents)
              return fetch(request)
                .then(resp => {
                  // this.checkUsers();
                })
            }
        });
      })

        unchecked.forEach(element => {
          const request = new Request(configAPI.api.prod + '/DownloadFile?path=ivr2:/AutherizedUsers/'+element+'.txt&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
          });
          fetch(request).then(data => data.text())
            .then(data => {
            var contents = data;
            var filename = data.match(/^\*.*\*/gm);
            filename = filename[0].replace(/\*/g,'');

            if (contents.indexOf('['+this.props.record.what+']')!==-1){
              var re = new RegExp('\\['+this.props.record.what + '\\]', "gm");
              contents = contents.replace(re, "");
              const request = new Request(configAPI.api.prod + '/UploadTextFile?&token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:AutherizedUsers/'+filename+'.txt&contents=' + contents)
              return fetch(request)
                .then(resp => {
                  // this.checkUsers();
                })
            }
        });
      })
      this.setState({open:false});
  };


  handleSendSubmit = (e, approve=false) => {
    e.stopPropagation();
    
    if (this.state.checked.length>0) this.updateUser();
  }
  
  handleToggle = value => () => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      checked: newChecked,
    });
  };


  render() {
    const { translate } = this.props;
    return (
      <Tooltip title={translate(`trans.LockFile`)}>
        <IconButton onClick={(e) => this.handleClickOpen(e)} >
          <Lock />
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
            onBackdropClick={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            <IconButton color="inherit" onClick={(e) => this.handleClose(e)} aria-label="Close" style={{ float: 'right' }}>
              <CloseIcon />
            </IconButton>
            <DialogTitle>
              {translate('trans.lockFile')}
            </DialogTitle>
            <DialogActions>
              <Button onClick={(e) => this.setState({open:false})} color="primary">
                {translate('ra.action.close')}
              </Button>
              <Button onClick={(e) => this.handleSendSubmit(e)} color="primary">
                {translate('ra.action.ok')}
              </Button>
            </DialogActions>

            <SimpleForm
              toolbar={false}
              defaultValue={{ average_note: 0 }}>
        <List>
          {this.state.userList.map((value, i) => (
            <ListItem
              key={value}
              role={undefined}
              dense
              button
              onClick={this.handleToggle(value)}
            >
              <Checkbox
                checked={this.state.checked.indexOf(value) !== -1}
                tabIndex={-1}
                disableRipple
                defaultChecked={this.state.defaultCheck[i]}
              />
              <ListItemText primary={value} />
              <ListItemSecondaryAction>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
            </SimpleForm>
          </Dialog>
          <Dialog
            open={this.state.openReplaceDialog}
            onClose={this.handleCloseReplaeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle>
              {translate('trans.override')}
            </DialogTitle>
            <DialogActions>
              <Button onClick={(e) => this.handleCloseReplaeDialog(e)} color="primary">
                {translate(`trans.cancel`)}
              </Button>
              <Button onClick={(e) => this.handleSendSubmit(e, true)} color="primary" autoFocus>
                {translate(`trans.ok`)}
              </Button>
            </DialogActions>
          </Dialog>
          </IconButton>
      </Tooltip>
    );
  }
}


export default connect(null, {
  push: pushAction,
})(translate(LockFile));
